import React from "react";

import { SharedCurrentUser } from "../../../lib/types";
import RandomColorAvatar from "../RandomColorAvatar";

import { Avatar, Box } from "@chakra-ui/react";

export const DrawerProfile = ({ currentUser }: { currentUser: NonNullable<SharedCurrentUser> }) => {
  if (currentUser?.is_all_public_feature_accessible) {
    return (
      <>
        <RandomColorAvatar
          src={currentUser.profile_image_url}
          bgColor={currentUser.real_name_avatar_bgcolor}
          name={currentUser.full_name}
          boxSize={9}
          sx={{ "--avatar-font-size": "1rem" }}
        />
        <Box as="span" fontSize="md">
          {currentUser.full_name}
        </Box>
      </>
    );
  } else if (currentUser.latest_personal_info_application_rejected || currentUser.personal_info_applicationing) {
    return (
      <>
        <Avatar boxSize={9} />
        <Box fontSize="sm">{currentUser.full_name}</Box>
      </>
    );
  } else {
    return (
      <>
        <Avatar boxSize={9} />
        <Box>
          <Box fontSize="sm">{currentUser.email}</Box>
        </Box>
      </>
    );
  }
};
